export default __webpack_public_path__ + "static/media/16-need.027d87b1.png";